import { useInjection } from "@linkfluence/core/di";
import { useQuery } from "@tanstack/react-query";
import {
  InsightPageRepo,
  InsightPageRepositoryUID,
} from "../repositories/InsightPageRepo";

export function useDiscovery(
  projectId: number,
  workspaceId: number,
  params?: Record<string, unknown>
) {
  const repository = useInjection<InsightPageRepo>(InsightPageRepositoryUID);
  const { data, isLoading, isRefetching, isRefetchError, isError, refetch } =
    useQuery(
      ["/insight-page/getDiscovery", { projectId, workspaceId, params }],
      () => {
        return repository.getDiscoveryPage(projectId, workspaceId, params);
      },
      { retry: 0 }
    );
  return {
    loading: isLoading || isRefetching,
    data,
    isError: isError || isRefetchError,
    refetch,
  };
}
